import { string as yupString } from "yup";

const emailSchema = yupString().email();

export const validateEmail = (email: string) => emailSchema.isValidSync(email);
